import { createFileRoute, redirect } from '@tanstack/react-router';

import { EmailSettings } from '~features/settings/email-settings/index';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { UserRoles } from '~entities/users';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/_settings/email-settings')(
  {
    beforeLoad: async () => {
      const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
      if (!hasAccess) {
        return redirect({
          to: '/dashboard',
        });
      }
    },
    pendingComponent: PendingComponent,
    component: EmailSettings,
  },
);
